import {onMounted, onBeforeUnmount} from 'vue'
import { $config } from '@/global/index'
import {useRouter} from 'vue-router'

export function getCanvasLimitHeight(resolution:string | null | undefined) {
    if(typeof resolution !== 'string' || !resolution){
        return undefined;
    }
    const [widthStr, heightStr] = resolution.toLowerCase().split('x');
    if(!widthStr || !heightStr){
        return undefined;
    }
    return heightStr;
}
/**
 * @description 监听webapi事件
 * @param typeMap 要监听的webapi事件Map列表
 * @param receiveMessage 处理webapi事件的方法
 */
export default function useReceiveMessage(
    typeMap?:Map<string,string>,
    receiveMessage?:(type:string,data:any)=>void
) {
    const engineName = $config.ENGINE_NAME;
    const router = useRouter();

    function onReceiveMessage(event: MessageEvent) {
        if (!event) return;
        const raw = event.data;
        if (raw == null || typeof raw !== 'object') return;
        const data = raw as Record<string, unknown>;
        if (!data.webApiSource && data.engineName && data.engineName !== engineName) return;
        if (data.webApiSource) {
            if (typeMap && typeMap.has(data.type as string)) {
                receiveMessage && receiveMessage(data.type as string, data);
            }
        }
    }

    // 打开全屏设置页面
    function handleOpenSettingFullscreen(isReady: boolean) {
        window?.playClick()
        if(!isReady) return;
        window.listenEvent.emit('open-setting-fullscreen');
    }

    function handleBack(type?:string) {
        if(type != 'Escape'){
            window?.playClick()
        }
        try {
            const value = sessionStorage.getItem('pilotAssessmentTrainingContext')
            if (value) {
                const context = JSON.parse(value) as {
                    sessionId?: string | number
                    roundId?: string | number
                }
                if (context.sessionId && context.roundId) {
                    router.push({
                        name: 'CandidateSubjects',
                        params: { sessionId: String(context.sessionId) },
                        query: { roundId: String(context.roundId) },
                    })
                    return
                }
            }
        } catch {
            sessionStorage.removeItem('pilotAssessmentTrainingContext')
        }
        router.push({
            path: '/home',
        })
    }

    onMounted(() => {
        window.addEventListener('message', onReceiveMessage);
    })

    onBeforeUnmount(() => {
        window.removeEventListener('message', onReceiveMessage);
    })

    return {
        handleOpenSettingFullscreen,
        handleBack
    }
}
